"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBarLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Layout = require("design_system/Layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  link: {
    position: "flex",
    text: "text-gray-171731 whitespace-no-wrap",
    font: "font-500",
    p: "py-24 px-16 s768:p-0",
    m: "s768:mr-32",
    hover: "s768:hover:underline",
    focus: "s768:focus:underline s768:focus:outline-none",
    border: "border-gray-e7e9ef border-solid border-b-1 last:border-b-0 s768:border-none"
  }
};
const NavBarLink = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    as: "a",
    text: THEME.link.text,
    font: THEME.link.font,
    p: THEME.link.p,
    m: THEME.link.m,
    hover: THEME.link.hover,
    focus: THEME.link.focus,
    border: THEME.link.border,
    className: (0, _classnames.default)(THEME.link.position, className),
    ref: ref,
    role: "menuitem",
    tabIndex: 0
  }, props), children);
});
exports.NavBarLink = NavBarLink;
NavBarLink.displayName = "NavBar.Link";